module.exports = __webpack_public_path__ + "img/korea.25a11cb0.svg";